const MenuActionTypes = {
	TOGGLE_MENU_HIDDEN: "TOGGLE_MENU_HIDDEN",
	SIDE_MENU_HIDE: "SIDE_MENU_HIDE",
	SIDE_MENU_ACTIVE: "SIDE_MENU_ACTIVE",
	ACTIVE_HEADER_BUTTON: "ACTIVE_HEADER_BUTTON",
};

export default MenuActionTypes;
